import React, { useState } from 'react';
import useIsMounted from 'ismounted';
import { useSnackbar } from 'notistack';
import T from 'i18n-react';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import Hidden from '@material-ui/core/Hidden';
import {
  FOLLOWING_BUSINESSES,
  LOGOUT,
  USER_SCHEDULES,
  MYPAGE_PROFILE,
  MYPAGE_ACCOUNT,
  USER_PAYMENT,
  USER_SKILLS,
  USER_WITHHOLDINGS,
} from '../../../routing';
import AppAvatar from '../../../../core/Avatar/AppAvatar';
import { getDynamicMenus } from '../utils';
import { signOutFbUser } from '../../../../core/firebase/auth';
import { handleMethod } from '../../../../core/ujs/method';
import DefaultImg from '../../../../../images/user/default.png';
import ProfileMenuListItem from '../molecules/ProfileMenuListItem';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: 0,
    margin: theme.spacing(0, 0, 0, 1),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 0, 0, 2),
    },
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
  },
  tooltip: {
    zIndex: theme.zIndex.tooltip,
  },
}));

// TODO TS化
const AccountMenu = ({
  loaded,
  imageUrl,
  profileMenuEl,
  handleOpenProfileMenu,
}) => {
  const classes = useStyles();
  const isMounted = useIsMounted();
  const { enqueueSnackbar } = useSnackbar();
  const [disabled, setDisabled] = useState(false);

  const handleToggle = (event) => {
    handleOpenProfileMenu(event.currentTarget);
  };

  const dynamicMenus = getDynamicMenus();

  const logout = () => {
    setDisabled(true);
    signOutFbUser()
      .then(() => {
        if (isMounted.current) {
          handleMethod(LOGOUT, { method: 'delete' });
        }
      })
      .catch((error) => {
        if (isMounted.current) {
          setDisabled(false);
          enqueueSnackbar(T.translate('form.error'), { variant: 'error' });
        }
      });
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open account menu"
        edge="end"
        onClick={handleToggle}
        className={classes.button}
      >
        <AppAvatar
          className={classes.avatar}
          loaded={loaded}
          src={imageUrl || DefaultImg}
          classes={{ img: 'user--image' }}
        />
      </IconButton>
      <Popper
        open={Boolean(profileMenuEl)}
        anchorEl={profileMenuEl}
        transition
        ref={(ref) => ref?.classList?.add?.(classes.tooltip)}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => handleOpenProfileMenu(null)}>
            <Fade {...TransitionProps}>
              <Paper elevation={3}>
                <List className={classes.list}>
                  <ProfileMenuListItem href={MYPAGE_PROFILE}>
                    {T.translate('menu.profile')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem href={MYPAGE_ACCOUNT}>
                    {T.translate('menu.account')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem href={FOLLOWING_BUSINESSES}>
                    {T.translate('menu.following')}
                  </ProfileMenuListItem>

                  {dynamicMenus.length > 0 && (
                    <Hidden lgUp implementation="css">
                      {dynamicMenus.map(({ text, href }) => (
                        <ProfileMenuListItem href={href} key={href}>
                          {text}
                        </ProfileMenuListItem>
                      ))}
                    </Hidden>
                  )}

                  <ProfileMenuListItem href={USER_SCHEDULES}>
                    {T.translate('user.titles.schedules')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem href={USER_SKILLS}>
                    {T.translate('user.titles.skills')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem href={USER_PAYMENT}>
                    {T.translate('user.titles.payments')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem href={USER_WITHHOLDINGS}>
                    {T.translate('user.titles.withholding_slips')}
                  </ProfileMenuListItem>
                  <ProfileMenuListItem
                    disabled={disabled}
                    onClick={logout}
                    style={{ width: '100%' }}
                  >
                    {T.translate('menu.logout')}
                  </ProfileMenuListItem>
                </List>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

export default AccountMenu;
